/** @license DAFT Core v1.2.0
* Copyright 2020 Texas A&M Center for Applied Technology,
* Texas A&M Engineering Experiment Station, The Texas A&M
* University System.
*
* This source code/schema and any derivative work is Texas
* A&M Engineering Experiment Station intellectual property
* and protected by copyright law. Usage is restricted solely
* to the FARM Animal Care and Environmental Stewardship
* programs administered by the National Milk Producers
* Federation. Dissemination of this source code and/or
* derivative work creation is strictly prohibited without
* express written permission from the Texas A&M Engineering
* Experiment Station.
*/

// todo make generic
export interface DataProvider {
  getData(params: any): Promise<object | null>;
}

/**
 * Registry of local data providers (IDB, SessionStorage, etc.). Providers are keyed by entity name.
 *
 * @example
 * ```ts
 *  {
 *    registry: {
 *      users: {
 *        getData(): {
 *          // implement get from IDB
 *        }
 *      }
 *    }
 *  }
 * ```
 */
export class DataProviderRegistry {
  registry: { [key: string]: { getData: (params: any) => any } };

  constructor() {
    this.registry = {};
  }

  register(serviceId: string, dp: DataProvider) {
    if (typeof serviceId !== 'string') {
      throw new Error('IllegalArgumentException: serviceId must be a string');
    }

    if (typeof dp !== 'object' || typeof dp.getData !== 'function') {
      throw new Error('IllegalArgumentException: data provider does not conform to DataProvider interface');
    }

    this.registry[serviceId] = dp;
  };

  getDataProvider(t: string) {
    if (typeof t !== 'string') {
      throw new Error('IllegalArgumentException: serviceId must be a string');
    }
    return this.registry[t] || null;
  };
}

export const dataProviderRegistry = new DataProviderRegistry;
